'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketingServices = undefined;

var _Hubs$HUB_MARKETING$H;

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PrimaryServices = [_MerchandiseIds.SERVICE_INBOUND_CONSULTING_MONTHLY, _MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONGOING, _MerchandiseIds.SERVICE_TECHNICAL_CONSULTING_ONGOING, _MerchandiseIds.SERVICE_PREMIUM_CONSULTING];

var MarketingServices = exports.MarketingServices = [].concat(PrimaryServices, [_MerchandiseIds.SERVICE_TRAINING_MARKETING_FUNDAMENTALS]);

exports.default = (_Hubs$HUB_MARKETING$H = {}, _defineProperty(_Hubs$HUB_MARKETING$H, _Hubs2.default.HUB_MARKETING, {
  primaryMerch: MarketingServices
}), _defineProperty(_Hubs$HUB_MARKETING$H, _Hubs2.default.HUB_SALES, {
  primaryMerch: PrimaryServices
}), _defineProperty(_Hubs$HUB_MARKETING$H, _Hubs2.default.HUB_SERVICE, {
  primaryMerch: PrimaryServices
}), _defineProperty(_Hubs$HUB_MARKETING$H, 'growth-suite', {
  primaryMerch: MarketingServices
}), _Hubs$HUB_MARKETING$H);


//////////////////
// WEBPACK FOOTER
// ./js/constants/HubToServicesMap.js
// module id = 367
// module chunks = 3 4 5